import { ApiError } from './api';

/**
 * Änderungen, die Formulare betreffen (Spalte, Feld, Auswahlwerte löschen): Der Server antwortet mit 409
 * und `details.formDeps`. Erst nach ausdrücklicher Bestätigung mit `?formulare=bestaetigt` erneut senden (V02).
 * Gibt `undefined` zurück, wenn abgebrochen wurde.
 */
export async function withFormConfirm<T>(run: (query: string) => Promise<T>): Promise<T | undefined> {
  try {
    return await run('');
  } catch (e) {
    const deps = e instanceof ApiError && e.status === 409 ? (e.data as { details?: { formDeps?: { id: string; title: string }[] } } | undefined)?.details?.formDeps : undefined;
    if (!deps?.length) throw e;
    if (!window.confirm(`${e instanceof Error ? e.message : ''}\n\nTrotzdem fortfahren?`)) return undefined;
    return run('?formulare=bestaetigt');
  }
}
